/* Manich scroll-reveal — diskret fade-up, 2026-07-26 */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  document.addEventListener('DOMContentLoaded', function () {
    var scope = document.querySelector('.shopify-section--main-page .prose');
    if (!scope) return;
    var targets = scope.querySelectorAll('section, h2, h3, .card, figure, [class*="step"], [class*="trin"], [class*="case"], [class*="stat"]');
    targets.forEach(function (el) {
      el.classList.add('manich-reveal');
      observer.observe(el);
    });
  });
})();
